import { RouteConfig } from 'vue-router';
import SandboxQuoteDetails from './quotehistory/quotedetails/quotedetails.component.vue';
import SandboxPrintQuoteDetail from './quotehistory/quotedetails/printQuoteDetail.vue';
import SandboxQuoteHistory from './quotehistory/quotehistory.component.vue';

export const SandboxQuoteDetailsRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'quoteDetails',
  component: SandboxQuoteDetails,
};

export const SandboxPrintQuoteDetailRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'quoteReceipt',
  component: SandboxPrintQuoteDetail,
};

export const SandboxQuoteHistoryRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'quotehistory',
  component: SandboxQuoteHistory,
};
